/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__IdInputs */

const de__field__id = /** @type {(inputs: _Field__IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbank-ID`)
};

/**

* @param {_Field__IdInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field__id = /** @type {((inputs?: _Field__IdInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__IdInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field__id(inputs)
});